// extracted by mini-css-extract-plugin
export default {"wrapper":"MyButton_wrapper__S9dkT"};